import './devSuppressResizeObserverError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Our atomic design system */
import './styles/index.css';

import App from './App';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || 'development',
});

// React Query is provided ONCE, inside App via PersistQueryClientProvider
// (the single source of truth for query defaults + the persisted cache). The
// redundant outer QueryClientProvider that used to live here was dead — App's
// inner provider won for every component — and its conflicting config (30s vs
// App's defaults) was pure confusion. App renders no queries before its own
// provider, so there's nothing to wrap here.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
